import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  page: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    maxWidth: "760px",
    padding: `${designTokens.spacing[6]} ${designTokens.spacing[4]}`,
    boxSizing: "border-box",
    "@media (min-width: 768px)": {
      padding: `${designTokens.spacing[8]} ${designTokens.spacing[6]}`,
    },
  },
  header: {
    marginBottom: designTokens.spacing[5],
    paddingTop: designTokens.spacing[4],
  },
  title: {
    fontSize: designTokens.fontSize["2xl"],
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.primary[900],
    lineHeight: designTokens.lineHeight.tight,
    margin: 0,
    "@media (max-width: 480px)": {
      fontSize: designTokens.fontSize.xl,
    },
  },
  updated: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    display: "block",
    marginTop: designTokens.spacing[2],
  },
  toc: {
    marginTop: designTokens.spacing[4],
    marginBottom: designTokens.spacing[5],
    backgroundColor: designTokens.primary[50],
    borderRadius: designTokens.borderRadius.lg,
    padding: `${designTokens.spacing[4]} ${designTokens.spacing[5]}`,
    border: `1px solid ${designTokens.primary[100]}`,
  },
  tocHeading: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.primary[800],
    textTransform: "uppercase",
    letterSpacing: designTokens.letterSpacing.wide,
    marginBottom: designTokens.spacing[3],
    marginTop: 0,
  },
  tocList: {
    display: "grid",
    rowGap: designTokens.spacing[2],
    paddingLeft: designTokens.spacing[5],
    listStyleType: "disc",
    margin: 0,
    "@media (min-width: 640px)": {
      gridTemplateColumns: "1fr 1fr",
    },
  },
  tocLink: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.accent[600],
  },
  section: {
    marginBottom: designTokens.spacing[6],
    paddingTop: designTokens.spacing[3],
    borderTop: `1px solid ${designTokens.neutral[200]}`,
  },
  sectionTitle: {
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.primary[900],
    marginTop: 0,
    marginBottom: designTokens.spacing[8],
  },
  subSectionTitle: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.primary[900],
    marginTop: designTokens.spacing[5],
    marginBottom: designTokens.spacing[2],
  },
  paragraph: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[700],
    lineHeight: `${designTokens.lineHeight.relaxed}`,
    margin: 0,
    marginBottom: designTokens.spacing[3],
  },
  list: {
    margin: 0,
    marginBottom: designTokens.spacing[3],
    paddingLeft: designTokens.spacing[5],
    listStyleType: "disc",
    display: "grid",
    rowGap: designTokens.spacing[2],
  },
  nestedList: {
    margin: 0,
    marginTop: designTokens.spacing[1],
    paddingLeft: designTokens.spacing[5],
    listStyleType: "circle",
    display: "grid",
    rowGap: designTokens.spacing[1],
  },
  listItem: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[700],
    lineHeight: `${designTokens.lineHeight.relaxed}`,
  },
  link: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.accent[600],
  },
  footnote: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    fontStyle: "italic",
    lineHeight: `${designTokens.lineHeight.relaxed}`,
    margin: 0,
  },
  skipLink: {
    position: "absolute",
    left: "-10000px",
    top: "auto",
    width: "1px",
    height: "1px",
    overflow: "hidden",
    ":focus": {
      position: "static",
      width: "auto",
      height: "auto",
      backgroundColor: designTokens.neutral.white,
      padding: `${designTokens.spacing[1]} ${designTokens.spacing[2]}`,
      border: `1px solid ${designTokens.neutral[300]}`,
      borderRadius: designTokens.borderRadius.md,
    },
  },
});
